<template>
  <div class="container-fluid mt--12">
    <actions-termo/>
    <div class="row">
      <div class="col-sm-12 col-lg-12">
        <lista-termo/>
      </div>
    </div>
  </div>
</template>

<script>
import TermoResponsabilidadeListaDetalhada from "./TermoResponsabilidadeListaDetalhada";
import TermoResponsabilidadeActions from "./TermoResponsabilidadeActions";
export default {
  name: "TermoResponsabilidadeContainerLista",
  components: {
    "lista-termo": TermoResponsabilidadeListaDetalhada,
    "actions-termo": TermoResponsabilidadeActions
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/termoResponsabilidade/TermoResponsabilidadeContainerLista.vue